export const CONFIG = {
  publishableKey: {
    staging: 'pk_test_J5al6oiFamDYYnsfQ67KhfUH',
    production: 'pk_live_V3lLv7pxn8mogqi7uKHipwgI'
  }
};



// WEBPACK FOOTER //
// ./src/app/config/stripe.config.ts